import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnhide = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.40665 6.40476C5.37002 6.96995 4.66667 8.0695 4.66667 9.33333C4.66667 11.1743 6.15905 12.6667 8 12.6667C9.26442 12.6667 10.3644 11.9627 10.9294 10.9252M14 9.33333C14 6.01962 11.3137 3.33333 8 3.33333C7.70546 3.33333 7.41587 3.35456 7.13268 3.39556M2 9.33333C2 7.33796 2.97403 5.57009 4.47256 4.47924M2 2L14 14",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgUnhide;
